import { createReducer, on } from '@ngrx/store';
// NgRx actions
import { clearPageErrorMessage, setPageErrorMessage, removePageErrorMessages } from './page-error-message.action';
export const PAGE_ERROR_MESSAGE_STATE_SLICE_KEY = 'pageErrorMessage';
export const pageErrorMessage = createReducer([], on(setPageErrorMessage, (state, action) => {
    if (action.message) {
        return state.concat([action.message]);
    }
    return state;
}), on(removePageErrorMessages, (state, action) => {
    return state.filter((message) => action.messages.indexOf(message) === -1);
}), on(clearPageErrorMessage, () => {
    return [];
}));
